import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import TopBanner from "../components/TopBanner";
import SearchDrawer from "../components/SearchDrawer";
import MobileMenu from "../components/MobileMenu";
import { BottomNavBar } from "../components/BottomNavBar";

export default function Layout() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname, location.search]);

  return (
    <>
      <TopBanner />
      <Header
        onSearchOpen={() => setSearchOpen(true)}
        onMobileMenuOpen={() => setMobileMenuOpen(true)}
      />
      <main>
        <Outlet />
      </main>
      <BottomNavBar onSearchOpen={() => setSearchOpen(true)} />
      <Footer />
      <SearchDrawer open={searchOpen} onClose={() => setSearchOpen(false)} />
      <MobileMenu
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      />
    </>
  );
}
